import { z } from 'zod';
export var CustomProfileFieldType;
(function (CustomProfileFieldType) {
    /* Primitive types */
    CustomProfileFieldType["Text"] = "Text";
    CustomProfileFieldType["Number"] = "Number";
    CustomProfileFieldType["Date"] = "Date";
    CustomProfileFieldType["Checkbox"] = "Checkbox";
    CustomProfileFieldType["Select"] = "Select";
    CustomProfileFieldType["Url"] = "Url";
    CustomProfileFieldType["Regex"] = "Regex";
    /* Composite types */
    CustomProfileFieldType["Address"] = "Address";
    CustomProfileFieldType["Fullname"] = "Fullname";
})(CustomProfileFieldType || (CustomProfileFieldType = {}));
export const customProfileFieldTypeGuard = z.nativeEnum(CustomProfileFieldType);
export const fieldOptionGuard = z.object({
    label: z.string().optional(),
    value: z.string(),
});
export const fieldOptionsGuard = fieldOptionGuard.array();
export const baseConfigGuard = z.object({
    placeholder: z.string().max(256).optional(),
    minLength: z.number().int().min(0).optional(),
    maxLength: z.number().int().min(0).optional(),
    minValue: z.number().int().min(0).optional(),
    maxValue: z.number().int().min(0).optional(),
    format: z.string().max(128).optional(),
    customFormat: z.string().max(128).optional(),
    options: fieldOptionsGuard.optional(),
    defaultValue: z.string().optional(),
});
export const fieldPartGuard = z.object({
    enabled: z.boolean(),
    name: z.string(),
    type: customProfileFieldTypeGuard,
    label: z.string().min(1).optional(),
    description: z.string().optional(),
    required: z.boolean(),
    config: baseConfigGuard.optional(),
});
export const fieldPartsGuard = fieldPartGuard.array();
export const customProfileFieldConfigGuard = baseConfigGuard.extend({
    parts: fieldPartsGuard.optional(),
});
